import ReactGA4 from 'react-ga4';

const InitializeGoogleAnalytics = (id) => {
  // Initialize GA4 - Add your measurement ID
  ReactGA4.initialize(id);
};

const TrackGoogleAnalyticsEvent = (category, eventName, data) => {
  // Send GA4 Event
  const eventParams = {
    category,
    ...data,
  };
  ReactGA4.event({
    eventName,
    eventParams,
  });
};

export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent };
